import * as agendaStyles from '../../../styles/widgets/agenda.module.scss';
import PropTypes from 'prop-types';

import {Link} from 'gatsby';
import React from 'react';
import clsx from 'clsx';
import {getDisplayLang} from '../../../utils/parsing';
import { getObjectUrl } from '../../../utils/utils';

const Agenda = ({elem, locale, indexEventGuide, siteURL, column, row}) => {
  let event;
  if (elem.__typename === 'CmsPortalComponentWidgetAgenda'){
    event = elem.event;
  } else {
    event = elem.events?.length > indexEventGuide ? elem.events[indexEventGuide++] : null;
  }
  const date = event?.start_date;
  const eventLanguage = event?.evt_language;
  const title = event?.title;
  let link = getObjectUrl(siteURL, event?.slug, 'event', locale);
  const parsedDate = new Date(date).toLocaleString('fr', {
    day: '2-digit', month: '2-digit', timeZone:'CET'
  });

  const displayLang = getDisplayLang(eventLanguage, locale);
  if (!link) {
    link = '#';
  }

  return (
    <Link
      className={agendaStyles.link}
      to={link}
    >
      <div
        style={{
          paddingBottom: `calc((100% / ${column}) * (${row}))`,
          gridArea: '1 / 1 / -1 / -1'
        }}
      />
      <div
        className={clsx(agendaStyles.bloc, {
          [agendaStyles.hover]: Boolean(link),
        })}
      >
        <div className={agendaStyles.innerBloc}>
          <div
            className={agendaStyles.mainBloc}
          >
            <div className={agendaStyles.itemMainBloc}>
              <div
                className={agendaStyles.titleAgenda}
              >
                <p className={agendaStyles.h3}>
                  AGENDA
                </p>
              </div>
              <div className={agendaStyles.containerDate}>
                {date?.length > 4
                && (
                  <div>
                    <p
                      className={clsx(agendaStyles.h1, agendaStyles.h1Hover)}
                    >
                      {`${parsedDate[0]}${parsedDate[1]}`}
                    </p>
                    <p
                      className={agendaStyles.h1}
                    >
                      /
                    </p>
                    <p
                      className={clsx(agendaStyles.h2, agendaStyles.h2Hover)}
                    >
                      {`${parsedDate[3]}${parsedDate[4]}`}
                    </p>
                  </div>
                )}
              </div>
              <div className={agendaStyles.containerTitle}>
                <p className={clsx(agendaStyles.agendaH4, agendaStyles.h4)}
                  lang={displayLang}
                >
                  {title}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Link>);
};

Agenda.propTypes = {
  column: PropTypes.number,
  date: PropTypes.string,
  elem: PropTypes.object,
  eventLanguage: PropTypes.string,
  indexEventGuide: PropTypes.number,
  link: PropTypes.string,
  locale: PropTypes.string,
  row: PropTypes.number,
  siteURL: PropTypes.string,
  title: PropTypes.string
};

export default Agenda;
